import { startG3Telemetry } from './g3-telemetry/index.js';
import '@fontsource-variable/bricolage-grotesque/opsz.css';
import './styles.css';
import { state } from './state.js';
import { api, setUnauthorizedHandler, NO_CONNECTION } from './api.js';
import { startRouter, go } from './router.js';
import { errorScreen } from './shell.js';
import { setupView, signInView, joinView } from './views/account.js';
import { feedView } from './views/feed.js';
import { placeView } from './views/place.js';
import { editView } from './views/edit.js';
import { settingsView } from './views/settings.js';
import { inviteView } from './views/invite.js';
import { startInstallPrompt, offerInstall } from './install.js';

startG3Telemetry({
  ingestUrl: G3_INGEST_URL,
  reportToken: G3_REPORT_TOKEN,
  commit: G3_COMMIT_SHA,
  deployUrl: G3_DEPLOY_URL,
});
startInstallPrompt();

// The Map and Add screens carry MapLibre (over 1 MB): it loads when one of them is first opened,
// so the Feed does not wait for it. The member is told the usual thing about a file that cannot
// load; the console keeps the original error, in case it was a fault in the module itself.
const lazy = (load, name) => async params => {
  let module;
  try {
    module = await load();
  } catch (e) {
    console.error(e);
    throw new Error(NO_CONNECTION, { cause: e });
  }
  return module[name](params);
};
const mapView = lazy(() => import('./views/map.js'), 'mapView');
const addView = lazy(() => import('./views/add.js'), 'addView');

const ROUTES = [
  [/^\/$/, feedView],
  [/^\/map$/, mapView],
  [/^\/add$/, addView],
  [/^\/places\/(?<id>\d+)$/, placeView],
  [/^\/places\/(?<id>\d+)\/edit$/, editView],
  [/^\/settings$/, settingsView],
  [/^\/invite$/, inviteView],
];

function resolve(path) {
  if (state.needsSetup) return { view: setupView };
  if (!state.user) {
    const join = path.match(/^\/join\/(?<token>[^/]+)$/);
    return join ? { view: joinView, params: join.groups } : { view: signInView };
  }
  for (const [pattern, view] of ROUTES) {
    const m = path.match(pattern);
    if (m) return { view, params: m.groups };
  }
  return { view: feedView };
}

setUnauthorizedHandler(() => {
  state.user = null;
  go(location.pathname, '', { replace: true });
});

async function boot() {
  try {
    Object.assign(state, await api('GET', '/api/session'));
  } catch (x) {
    document.getElementById('app').replaceChildren(errorScreen(x.message));
    return;
  }
  startRouter(resolve, offerInstall);
}
boot();
